module.exports = __webpack_public_path__ + "media/images/advisor/img_2_2-348eb3085d0487050e763d21c37970ba.png";